import { motion, AnimatePresence } from "framer-motion";
import { ScrollSymbol } from "@/components/ScrollSymbol";

interface LoadingSplashProps {
  isVisible: boolean;
  onExitComplete?: () => void;
}

export default function LoadingSplash({ isVisible, onExitComplete }: LoadingSplashProps) {
  return (
    <AnimatePresence onExitComplete={onExitComplete}>
      {isVisible && (
        <motion.div
          key="splash"
          className="fixed inset-0 z-9999 flex flex-col items-center justify-center"
          style={{ background: "#FDFCFA" }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        >
          {/* Scroll symbol */}
          <motion.div
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              delay: 0.15,
              duration: 0.5,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            <ScrollSymbol size={48} color="#1D1916" />
          </motion.div>

          {/* Wordmark */}
          <motion.span
            className="select-none"
            style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: 44,
              color: "#1D1916",
              letterSpacing: -1,
              lineHeight: 1,
              marginTop: 10,
            }}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.4,
              duration: 0.5,
              ease: "easeOut",
            }}
          >
            scroll
          </motion.span>

          {/* Subtle pulsing dots as loading indicator */}
          <motion.div
            className="mt-8 flex gap-1.5"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9, duration: 0.3 }}
          >
            {[0, 1, 2].map((i) => (
              <motion.div
                key={i}
                className="rounded-full"
                style={{
                  width: 4,
                  height: 4,
                  background: "rgba(29, 25, 22, 0.3)",
                }}
                animate={{ opacity: [0.3, 1, 0.3] }}
                transition={{
                  delay: 1.0 + i * 0.15,
                  duration: 1.0,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />
            ))}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
